import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=48074116&scoped=true&"
import script from "./navItem.vue?vue&type=script&lang=js&"
export * from "./navItem.vue?vue&type=script&lang=js&"
import style0 from "./navItem.vue?vue&type=style&index=0&id=48074116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48074116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48074116')) {
      api.createRecord('48074116', component.options)
    } else {
      api.reload('48074116', component.options)
    }
    module.hot.accept("./navItem.vue?vue&type=template&id=48074116&scoped=true&", function () {
      api.rerender('48074116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReportNav/navItem.vue"
export default component.exports